<template>
  <div>
    <ApolloQuery
      :query="require('../graphql/ObrasServicos.gql')"
      :clientId="client"
      :variables="{ entidade }"
      :skip="!entidade"
      :update="data => {
        var result = data.obrasServicos.map(obraServico => {
          if (this.all && obraServico.url) {
            obraServico.url += '?all=true';
          }
          if (obraServico.apelido) {
            obraServico.descricao = obraServico.apelido
          }
          if (obraServico.id) {
            obraServico.id = parseInt(obraServico.id)
          }
          if (obraServico.numero) {
            obraServico.numero = parseInt(obraServico.numero)
          }
          obraServico.tipo = formatEnumLabel(obraServico.tipo)
          return obraServico;
        })

        this.updateMarkers(result);

        return result
      }"
      :debounce="500"
    >
      <template slot-scope="{ result: { loading, error, data } }">
        <!-- Loading -->
        <div v-if="loading">Listando Obras...</div>

        <!-- Error -->
        <div v-else-if="error">{{ error.message }}</div>

        <!-- Result -->
        <div v-else-if="data">
          <table style="width: 100%">
            <tr v-if="markers.length">
              <td colspan="4">
                <mapa :markers="markers">
                </mapa>
              </td>
            </tr>
          </table>
          <b-table 
            ref="table"
            :data="data"
            :paginated="true"
            :per-page="10"
            :sort-icon-size="'is-small'"
            :pagination-position="'bottom'"
            :sticky-header="true"
            :height="'500px'"
            detailed
            detail-key="id"
            :show-detail-icon="showDetailIcon">

            <template v-for="column in columns">
                <b-table-column :key="column.id" v-bind="column">
                    <template
                        v-if="column.searchable && !column.numeric"
                        #searchable="props">
                        <b-select v-if="column.select"
                            v-model="props.filters[props.column.field]"
                            @click.native="atualizarMarkers"
                            @change.native="atualizarMarkers">
                            <option value="">Todos</option>
                            <option
                                v-for="option in column.selectOptions"
                                :value="option"
                                :key="option">
                                {{ option }}
                            </option>
                        </b-select>
                        <b-input v-else
                            v-model="props.filters[props.column.field]"
                            @keyup.native="atualizarMarkers"
                            @change.native="atualizarMarkers"/>
                    </template>
                    <template v-slot="props">
                      <span v-if="column.date">
                        {{ props.row[column.field] | formatDate }}
                      </span>
                      <span v-else-if="column.percentage">
                        {{ props.row[column.field] | numFormat('0,00%') }}
                      </span>
                      <span v-else-if="column.currency">
                        {{ props.row[column.field] | numFormat('$ 0,0.00') }}
                      </span>
                      <a v-else-if="column.details"
                        @click="props.toggleDetails(props.row)">
                        {{ props.row.descricao }}
                      </a>
                      <span v-else>
                        {{ props.row[column.field] }}
                      </span>
                    </template>
                    <template #empty>
                        <div class="has-text-centered">Nenhuma obra encontrada</div>
                    </template>
                </b-table-column>
            </template>

            <b-table-column field="url" label="" v-slot="props">
              <a :href="props.row.url" target="_blank">
                <b-icon
                  pack="fas"
                  icon="external-link-alt"
                  size="is-small">
                </b-icon>
              </a>
            </b-table-column>

            <template slot="detail" slot-scope="props">
              <obra-servico
                :id="props.row.id"
                :all="all"
                :entidade="entidade"
              ></obra-servico>              
            </template>

            <template #footer v-if="filterEmpty">
                <div class="has-text-centered">
                    Nenhuma obra encontrada para os filtros informados
                </div>
            </template>
          </b-table>
          <!-- <pre>
            {{
              data
            }}
          </pre> -->
        </div>

        <!-- No result -->
        <div v-else class="alert alert-warning">Listando Obras...</div>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import { icon } from "leaflet";

export default {
  data() {
    return {
      columns: [
        { field: 'numero', label: 'Obra', searchable: true, sortable: true },
        { field: 'descricao', label: 'Descrição', searchable: true, sortable: true },
        { field: 'tipo', label: 'Tipo', searchable: true, sortable: true },
        { field: 'situacao', label: 'Situação', searchable: true, sortable: true }
      ],
      markers: [],
      filterEmpty: false,
      iconParalisada: icon({
        iconUrl: "marker-icon-paralisada.png"
      }),
      iconCancelada: icon({
        iconUrl: "marker-icon-cancelada.png"
      }),
      iconConcluida: icon({
        iconUrl: "marker-icon-concluida.png"
      }),
      iconPlanejamento: icon({
        iconUrl: "marker-icon-planejamento.png"
      }),
      iconDefault: icon({
        iconUrl: "marker-icon.png"
      })
    };
  },
  props: {
    entidade: {
      default: null,
      type: Number
    },
    all: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    client() {
      return this.all ? 'v2' : 'v1'
    }
  },
  components: {
    ObraServico: () => import('./ObraServico.vue'),
    Mapa: () => import('./Mapa.vue')
  },
  methods: {
    updateMarkers(result) {
      this.filterEmpty = (result.length == 0)
      this.markers = result.filter(item => {
        return item.latitude && item.longitude
      }).map(item => {
        switch(item.situacao) {
          case 'PARALISADA_SUSPENSA':
            item.icon = this.iconParalisada
            break;
          case 'CANCELADA':
          case 'RESCINDIDA':
          case 'FRACASSADA':
          case 'DESERTA':
          case 'REVOGADA':
          case 'ANULADA':
            item.icon = this.iconCancelada
            break;
          case 'CONCLUIDA': 
            item.icon = this.iconConcluida
            break;
          case 'EM_PLANEJAMENTO':
          case 'AGUARDANDO_LICITACAO':
            item.icon = this.iconPlanejamento
            break;
          case 'AGUARDANDO_ORDEM_SERVICO':
          case 'EM_ANDAMENTO':
          default:
            item.icon = this.iconDefault;
        }
        return item
      })
    },
    atualizarMarkers() {
      let table = this.$refs.table
      this.$nextTick(() => {
        this.updateMarkers(table.newData);
      });
    },
    showMap(lat, lng) {
      return (lat && lng)
    },
    formatEnumLabel(enumName) {
      return this.$options.filters['formatEnumLabel'](enumName)
    }
  }
};
</script>